import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 11.25 11.25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.25.563v2.25a.56.56 0 0 1-.165.397.56.56 0 0 1-.795 0 .56.56 0 0 1-.165-.397V1.125H6.187v9h1.688a.562.562 0 1 1 0 1.125h-4.5a.562.562 0 1 1 0-1.125h1.688v-9H1.125v1.688a.56.56 0 0 1-.165.397.56.56 0 0 1-.795 0A.56.56 0 0 1 0 2.813V.563C0 .413.059.27.165.165A.56.56 0 0 1 .563 0h10.124c.15 0 .293.059.398.165a.56.56 0 0 1 .165.398"
    }, null, -1)
  ])))
}
export default { render: render }